import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { Jsa } from '../../../../services/jsa/jsa.interface';
import { JsaService } from '../../../../services/jsa/jsa.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonFunctionsService } from '../../../../services/common-functions.service';


@Component({
    selector: 'app-download-pdf',
    imports: [
        CommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatInputModule,
        MatRadioModule,
        MatFormFieldModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelect,
        MatOption,
        MatDatepickerModule,
        MatTableModule,
        MatIconModule
    ],
    templateUrl: './download-pdf.component.html',
    styleUrl: './download-pdf.component.css'
})
export class DownloadPdfComponent implements OnInit {
  form: FormGroup;
  searchConducted = false;
  isLoading = false;
  dataSource = new MatTableDataSource<Jsa>();
  totalSubmissions = 0;
  displayedColumns: string[] = ['office', 'date', 'projectNumber', 'projectName', 'clientName', 'fileUrl'];

  constructor(private fb: FormBuilder, private jsaService: JsaService, private commonFuncs: CommonFunctionsService) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      office: [null, Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
    });
  }

  onSubmit(): void {
    if (this.form.valid) {
      // Clear the table data
      this.dataSource.data = [];
      this.totalSubmissions = 0;
      
      this.searchConducted = true;
      this.isLoading = true; // Start spinner
      const { office, startDate, endDate } = this.form.value;

      const queryStartDate = this.commonFuncs.convertToUtc(startDate);
      const queryEndDate = this.commonFuncs.convertToUtcEod(endDate);
  
      this.jsaService.getPdfs(office, queryStartDate, queryEndDate).subscribe({
        next: (res: any) => {
          this.dataSource.data = [...res].sort(
            (a: any, b: any) =>
              new Date(b.userDateTime ?? b.date).getTime() -
              new Date(a.userDateTime ?? a.date).getTime()
          );
          this.totalSubmissions = res.length;
          this.isLoading = false;
        },
        error: (err) => {
          console.error(err); 
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }

  refreshData(): void {
    this.dataSource.data = [];
    this.totalSubmissions = 0;
    this.form.reset();
    this.searchConducted = false;
    this.isLoading = false; // Reset loading state
  }
}


